import AmpersandModel from 'ampersand-model';
import React from 'react';
import {convertLetterToColorNumber} from "../../gd/convert/letter-to-color-number";

module.exports = AmpersandModel.extend({
    idAttribute: "id",

    props: {
        id: 'string',
        name: 'string',
        icon: 'string',
        color: 'number',
        abbreviation: 'string'
    },
    derived: {
        initials: {
            deps: ['abbreviation'],
            fn: function() {
                return this.abbreviation;
            }
        },
        iconNormal: {
            deps: ['icon'],
            fn: function() {
                if (!this.icon) this.icon = '_def.png';
                return "/media/company/norm/"+this.icon;
            }
        },
        iconSmall: {
            deps: ['icon'],
            fn: function() {
                if (!this.icon) this.icon = '_def.png';
                return "/media/company/small/"+this.icon;
            }
        },
        iconLarge: {
            deps: ['icon'],
            fn: function() {
                if (!this.icon) this.icon = '_def.png';
                return "/media/company/large/"+this.icon;
            }
        },
        url: {
            deps: ['id'],
            fn: function() {
                return "o/"+this.id;
            }
        }
    },

    getColor() {
        const letter = gd.utils.initials(this.abbreviation,1).toLowerCase();
        return convertLetterToColorNumber(letter ? letter : 'a');
    },

    parse: function(obj){

        if (!obj.abbreviation) obj.abbreviation = gd.utils.initials(obj.name,2);

        // if color not set in DB -> generate from name
        if (!obj.color) obj.color = this.getColor()

        return obj;
    }

});